/* eslint-disable */

import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import vueScrollto from 'vue-scrollto'
Vue.use(vueScrollto)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import { messages, defaultLocale } from "@/lang";

const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale
});

import VueInstagram from 'vue-instagram'
Vue.use(VueInstagram)

import 'bootstrap'
import './assets/app.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import moment from 'moment-timezone'
Vue.prototype.moment = moment

import Parse from './parse' 
Vue.prototype.$parse = Parse 

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

export const bus = new Vue();

Vue.use(Buefy) 
Vue.config.productionTip = false

new Vue({
  router, 
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
